<template>
  <div v-if="add_ons.length">
    <div
      class="rounded border p-3 single-variant-addon-container mb-4"
      v-for="(addOnCategory, addOnCategoryIndex) in add_ons"
      :key="`add-on-category-$${addOnCategoryIndex}`"
    >
      <div class="font-weight-bold mb-2">{{ addOnCategory.name }}</div>
      <b-table
        :items="addOnCategory.items"
        :fields="fields"
        class="border"
        hover
        fixed
      >
        <template slot="sku" slot-scope="data">
          <b-form-input
            :id="`variant_sku_${data.index}`"
            v-model="data.item.variable.sku"
          >
          </b-form-input>
        </template>
        <template slot="visibility" slot-scope="data">
          <switches
            v-model="data.item.visibility"
            theme="custom"
            color="primary"
            type-bold="true"
            style="top: 12px"
            :emit-on-mount="false"
            disabled
          />
        </template>
        <template slot="is_free" slot-scope="data">
          <switches
            v-model="data.item.is_free"
            theme="custom"
            color="primary"
            type-bold="true"
            style="top: 12px"
            :emit-on-mount="false"
            disabled
          />
        </template>
        <template slot="price" slot-scope="data">
          <template v-if="data.item.is_free">
            N/A
          </template>
          <template v-else>
            ₱ {{ data.value }}
          </template>
        </template>
      </b-table>
      <b-button
        variant="single-manage"
        class="border-0 text-primary font-weight-bold mr-3"
        @click="manageAddOns(addOnCategoryIndex)"
        v-if="addOnCategory.items.length"
      >
        Manage Add-On
      </b-button>
      <b-button
        variant="ghost"
        class="bg-light text-muted font-weight-bold"
        @click="deleteAddOn(addOnCategoryIndex)">
        Delete
      </b-button>
    </div>
  </div>
</template>

<script>
import Switches from "vue-switches";
import { mapState } from "vuex";

export default {
  props: {
    mode: String,
  },
  components: { Switches },
  data() {
    return {
      fields: [
        {
          key: "name",
          thClass: "bg-light text-center border-bottom-0 border-right",
          tdClass: "border-right align-middle text-truncate",
        },
        {
          key: "visibility",
          thClass: "bg-light text-center border-bottom-0 border-right",
          tdClass: "border-right text-center",
        },
        {
          key: "is_free",
          thClass: "bg-light text-center border-bottom-0 border-right",
          tdClass: "border-right align-middle text-center",
        },
        {
          key: "price",
          thClass: "bg-light text-center border-bottom-0",
          tdClass: "border-right align-middle",
        },
      ],
    };
  },
  computed: {
    ...mapState("products", ["add_ons"]),
  },
  mounted() {
    this.$root.$on("productAddOnsUpdate", () => this.$forceUpdate());
  },
  beforeDestroy() {
    this.$root.$off("productAddOnsUpdate");
  },
  methods: {
    manageAddOns(addOnCategoryIndex) {
      this.$parent.$parent.is_manage = true;
      this.$parent.$parent.add_on_category_index = addOnCategoryIndex;
      this.$parent.$parent.create();
    },
    deleteAddOn(addOnCategoryIndex) {
      this.$store.commit("products/deleteAddOn", addOnCategoryIndex);
    }
  },
};
</script>

<style lang="scss">
.single-variant-addon-container {
  .btn.btn-single-manage {
    background-color: #f5f5f5;
  }
}
</style>
